import Dialog from '$tablet-app/src/app/components/Dialog';
import { palette } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { PasswordInput } from '@akin-home/forms/native';
import { spacing } from '@akin-home/theme';
import React, { useState } from 'react';
import { Text, View } from 'react-native';
import { SSIDDropdown } from './SSIDDropdown';

interface Props {
  connectToWifi: (
    ssid: string,
    password: string | undefined
  ) => Promise<string | boolean>;
  onClose: (success: boolean) => void;
}

export const ConnectToWifiModal = (props: Props) => {
  const [ssid, setSSID] = useState<string>();
  const [password, setPassword] = useState<string>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [errorText, setErrorText] = useState<string>('');

  const onSubmit = async () => {
    if (!ssid) {
      setErrorText('SSID cannot be empty');
      return;
    }
    setErrorText('');

    setIsLoading(true);

    const error = await props.connectToWifi(ssid, password);
    setIsLoading(false);

    // strict equality as we are looking for the `true` value only.
    if (error === true) {
      props.onClose(true);
    } else {
      if (error.toString().match(/No network with SSID/)) {
        setErrorText('No network with that SSID found by the robot');
      } else if (error.toString() === 'Bluetooth Disconnected') {
        setErrorText('Bluetooth disconnected, please try again');
      } else if (error.toString().match(/802-11-wireless-security.psk/)) {
        setErrorText('Incorrect Password');
      } else {
        setErrorText('Unknown error, please try again');
      }
    }
  };

  return (
    <Dialog visible={true} onClose={() => props.onClose(false)}>
      <View style={{ margin: spacing[3] }}>
        <Text style={{ fontSize: 22, fontWeight: 'bold' }}>
          Connect Robot to a Wifi Network
        </Text>

        <View style={{ marginTop: spacing[3] }}>
          <Text
            style={{
              fontSize: 18,
            }}
          >
            SSID (Required)
          </Text>

          <SSIDDropdown
            onSSIDSelect={(selectedSSID) => setSSID(selectedSSID)}
          />
        </View>

        <View style={{ marginTop: spacing[3] }}>
          <Text
            style={{
              fontSize: 18,
            }}
          >
            Password
          </Text>
          <PasswordInput
            value={password}
            onChangeText={(text) => setPassword(text)}
            placeholder="Enter WiFi Password"
          />
        </View>

        {errorText ? (
          <View
            style={{ marginTop: spacing[3], paddingHorizontal: spacing[2] }}
          >
            <Text
              style={{
                fontSize: 18,
                color: 'red',
              }}
            >
              {errorText}
            </Text>
          </View>
        ) : null}

        <View style={{ marginTop: spacing[3] }}>
          <Button
            size="large"
            onPress={onSubmit}
            disabled={!ssid || isLoading}
            style={
              (!ssid || isLoading) && {
                backgroundColor: palette.dim,
              }
            }
          >
            {ssid && isLoading ? 'Connecting...' : 'Connect to Wifi'}
          </Button>
        </View>
      </View>
    </Dialog>
  );
};
